"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ducd_1 = require("ducd");
const d3_1 = require("d3");
const navigation_sidebar_html_1 = require("./navigation-sidebar.html");
const M = require("materialize-css");
var langsmeta = [
    { id: 'de', text: 'Deutsch' },
    { id: 'en', text: 'English' },
    { id: 'es', text: 'Español' },
    { id: 'la', text: 'Latīna' },
    { id: 'sci', text: 'Latīna' },
    { id: 'nl', text: 'Nederlands' },
    { id: 'ru', text: 'Русский' },
    { id: 'ro', text: 'Română' },
    { id: 'he', text: 'עברית' },
    { id: 'fa', text: 'فارسی' },
    { id: 'ar', text: 'العربية' },
    { id: 'zh', text: '中文' },
    { id: 'ko', text: '한국어' },
];
var htmllang = `<a id='btn_lang' class='dropdown-button btn btn-small waves-effect' data-target='dropdown_lang'>
        <i class="material-icons">translate</i>
    </a>
    <ul id='dropdown_lang' class='dropdown-content'></ul>`;
var htmlstyleswitch = `<a id='btn_theme' class='dropdown-button btn btn-small waves-effect' data-target='dropdown_theme'>        
        <i class="material-icons btn-icon-darklightswitch">chrome_reader_mode</i>
    </a>
    <ul id='dropdown_theme' class='dropdown-content'>
        <li><a onclick="document.getElementById('ldswitch').setAttribute('href', 'hypertree-of-life-light.css'); monaco.editor.setTheme('vs')">Light</a></li>
        <li><a onclick="document.getElementById('ldswitch').setAttribute('href', 'hypertree-of-life-dark.css'); monaco.editor.setTheme('vs-dark')">Dark</a></li>
    </ul>`;
var fullscreen = `<a id="fullscreen" class='btn btn-small waves-effect'>        
        <i class="material-icons">fullscreen</i>
    </a>`;
var htmlAinc = `<a class='btn btn-small waves-effect disabled'>        
        A<sup>+</sup>                
    </a>`;
var htmlAdec = `<a class='btn btn-small waves-effect a-dec disabled'>
        A<sup>-</sup>
    </a>`;
var htmlbread = `<a href="#!" class="breadcrumb">Files</a>`;
var html = `<div class="slides-header">
        <div class="header">
            <span>
                <a href="/">
                    <img id="logo" src="img/avatar-light.png">
                </a>
                <!--
                <button id="btnroot" class="btn btn-small waves-effect waves-orange pn">🌍️</button>                
                
                <button id="btnprev" class="btn btn-small waves-effect waves-orange pn"><i class="material-icons btn-icon-prevnext">keyboard_arrow_left</i></button>
                <button id="btnnext" class="btn btn-small waves-effect waves-orange pn"><i class="material-icons btn-icon-prevnext">keyboard_arrow_right</i></button>
                
                <input id="query" type="text" class="browser-default">
                --> 
                <span id='breadcrumb'></span>
                <span id='breadcrumb2'></span>
            </span>
            <span class="configline">
                <!--
                <p style="margin:0.35em 2em 0 0;">
                    <input type="checkbox" id="test5" />
                    <label class="left" for="test5">Fast and ugly</label>
                </p>
                --> 
                
                ${htmllang}
                ${htmlstyleswitch}                
                <!--
                ${fullscreen}
                ${htmlAdec}
                ${htmlAinc}                
                ${navigation_sidebar_html_1.htmlnav}-->
            </span>
        </div>
        <div class="content">          
            <a href="https://twitter.com/intent/retweet?tweet_id=1033364887844610048">
                <img class="patron" src="img/twitter-01.png"></img>
            </a>
            <a href="https://www.facebook.com/sharer/sharer.php?u=https%3A//www.facebook.com/photo.php?fbid=10216282328108017">
                <img class="patron" src="img/facebook.png"></img>
            </a>
            <a href="https://www.patreon.com/user?u=11112015">
                <img class="patron" src="img/patreon.png"></img>
            </a>  
            <a href="https://github.com/glouwa/d3-hypertree">
                <img class="patron" src="img/github.png"></img>
            </a>  
        </div>
    </div>`;
function NavigationHTML(args) {
    var ui = ducd_1.HTML.parse(html)();
    args.parent.appendChild(ui); // <-- den strichpunkt braucht man :D
    // zumindest wenn ein ( folgt
    //(<HTMLElement>ui.querySelector('#logo')).onclick = ()=> window.location.href = `/`;    
    /*
    (<HTMLElement>ui.querySelector('#btnprev')).onclick = args.onPrevClick; // <-- den strichpunkt braucht man :D
    (<HTMLElement>ui.querySelector('#btnnext')).onclick = args.onNextClick;

    (<HTMLElement>ui.querySelector('#btnroot')).onclick = args.onRootClick;
    
    (<HTMLElement>ui.querySelector('#fullscreen')).onclick = ()=> {
        //document.body.webkitRequestFullScreen();
        document.documentElement.webkitRequestFullScreen();
    }
    
    const queryinput = <HTMLInputElement>ui.querySelector('#query')
    queryinput.oninput = e=> {
        const query = queryinput.value.length >= 5 ? queryinput.value : null
        args.onQuery(query)
    }
    queryinput.onkeypress = e=> {
        const query = queryinput.value
        if (e.code === 'Enter')
            args.onQuery(query)
    }
    */
    ui.updateLangs = (langs) => {
        const newlangset = langsmeta.filter(lm => langs.includes(lm.id));
        d3_1.selectAll('#dropdown_lang')
            .selectAll('li')
            .data(newlangset)
            .enter().append('li').append('a')
            .on('click', d => args.onLangChange(d.id, d.text))
            .html(d => d.text);
        d3_1.selectAll('#btn_lang')
            .classed("disabled", newlangset.length === 0);
    };
    ui.content = ui.querySelector('.content');
    ui.breadcrumb = ui.querySelector('#breadcrumb');
    ui.breadcrumb2 = ui.querySelector('#breadcrumb2');
    M.Sidenav.init(document.querySelector('#navlink'), { menuWidth: 400 });
    M.Collapsible.init(document.querySelector('.collapsible'));
    M.FormSelect.init(document.querySelector('.side-nav select'));
    M.Dropdown.init(document.querySelector('#btn_lang'), {
        inDuration: 300,
        outDuration: 225,
        constrainWidth: false,
        hover: false,
        gutter: 0,
        coverTrigger: false,
        alignment: 'left',
        stopPropagation: false // Stops event propagation        
    });
    M.Dropdown.init(document.querySelector('#btn_theme'), {
        inDuration: 300,
        outDuration: 225,
        constrainWidth: false,
        hover: false,
        gutter: 0,
        coverTrigger: false,
        alignment: 'left',
        stopPropagation: false // Stops event propagation        
    });
    return ui;
}
exports.NavigationHTML = NavigationHTML;



//////////////////
// WEBPACK FOOTER
// ./dist/js/components/navigation/navigation.html.js
// module id = 333
// module chunks = 0